import { Link } from 'react-router-dom';
import { CommonHeader } from '~/components';
import styles from './NotFound.module.scss';

function NotFound() {
    return (
        <>
            <CommonHeader title={'Not Found page'} />
            <Link to="/" className={styles.backToHome}>
                Quay lại trang chủ
            </Link>
        </>
    );
}

export default NotFound;
